import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { $getSelection } from "lexical";
import { useTheme } from "@mui/material/styles";
import { Box } from "../../../../../Box/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { DropdownButton } from "../../../../../DropdownButton/index.js";
import { Icon } from "../../../../../Icon/index.js";
import { MenuItem } from "../../../../../MenuItem/index.js";
import { Button } from "../../../../../Button/index.js";
import { useStyles } from "./useSymbols.styles.js";
import { arrowSymbols, currencySymbols, latinSymbols, mathematicalSymbols, textSymbols } from "./symbols.js";
const chapters = {
    all: 'Все',
    currrency: 'Валюта',
    text: 'Текст',
    mathematical: 'Математические',
    arrow: 'Стрелки',
    latin: 'Латинские'
};
const allSymbols = [
    ...currencySymbols,
    ...textSymbols,
    ...mathematicalSymbols,
    ...arrowSymbols,
    ...latinSymbols
];
const getCurrentSymbols = (type)=>{
    switch(type){
        case 'all':
            return allSymbols;
        case 'currrency':
            return currencySymbols;
        case 'text':
            return textSymbols;
        case 'mathematical':
            return mathematicalSymbols;
        case 'arrow':
            return arrowSymbols;
        case 'latin':
            return latinSymbols;
        default:
            return allSymbols;
    }
};
const useSymbols = (editor)=>{
    const $ = c(21);
    const { classes } = useStyles();
    const theme = useTheme();
    const [activeChapters, setActiveChapters] = useState("all");
    let t0;
    if ($[0] !== editor) {
        t0 = (symbol)=>{
            editor.update(()=>{
                const selection = $getSelection();
                null == selection || selection.insertRawText(symbol);
            });
        };
        $[0] = editor;
        $[1] = t0;
    } else t0 = $[1];
    const handleFormat = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (key)=>{
            setActiveChapters(()=>key);
        };
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    const t2 = `0 0 10px ${theme.tokens.colors.bg.light.primary}`;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = Object.entries(chapters).map((t4)=>{
            const [chapter, name] = t4;
            return /*#__PURE__*/ jsx(MenuItem, {
                onClick: ()=>handleClick(chapter),
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "subtitle2",
                    children: name
                })
            }, chapter);
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== activeChapters) {
        t4 = /*#__PURE__*/ jsx(DropdownButton, {
            size: "medium",
            menuItems: t3,
            variant: "tertiaryLight",
            verticalPosition: "bottom",
            horizontalPosition: "left",
            button: (t5)=>{
                const { onClick } = t5;
                return /*#__PURE__*/ jsx(Box, {
                    display: "flex",
                    alignItems: "center",
                    children: /*#__PURE__*/ jsx(Button, {
                        fullWidth: false,
                        variant: "tertiaryLight",
                        size: "medium",
                        onClick: onClick,
                        children: /*#__PURE__*/ jsxs(Box, {
                            display: "flex",
                            alignItems: "center",
                            gap: "4",
                            children: [
                                /*#__PURE__*/ jsx(Typography, {
                                    variant: "subtitle2",
                                    children: chapters[activeChapters]
                                }),
                                /*#__PURE__*/ jsx(Box, {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "9px",
                                    children: /*#__PURE__*/ jsx(Icon, {
                                        name: "dropdown",
                                        size: "16",
                                        color: "text.light.primary"
                                    })
                                })
                            ]
                        })
                    })
                });
            }
        });
        $[4] = activeChapters;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ jsx(Box, {
            position: "sticky",
            top: "0",
            left: "0",
            bgcolor: "bg.light.primary",
            boxShadow: t2,
            children: t4
        });
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== activeChapters || $[10] !== classes || $[11] !== handleFormat) {
        let t7;
        if ($[13] !== classes || $[14] !== handleFormat) {
            t7 = (symbol_0, index)=>/*#__PURE__*/ jsx(Box, {
                    className: classes.symbolItem,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "40px",
                    height: "32px",
                    border: "1px solid",
                    borderColor: "stroke.primary",
                    radius: "m",
                    onClick: ()=>handleFormat(symbol_0),
                    cursor: "pointer",
                    margin: "4",
                    children: /*#__PURE__*/ jsx(Typography, {
                        variant: "body3",
                        children: symbol_0
                    })
                }, index);
            $[13] = classes;
            $[14] = handleFormat;
            $[15] = t7;
        } else t7 = $[15];
        t6 = getCurrentSymbols(activeChapters).map(t7);
        $[9] = activeChapters;
        $[10] = classes;
        $[11] = handleFormat;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[16] !== t6) {
        t7 = /*#__PURE__*/ jsx(Box, {
            display: "flex",
            flexWrap: "wrap",
            px: "12",
            children: t6
        });
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== t5 || $[19] !== t7) {
        t8 = /*#__PURE__*/ jsx(Box, {
            maxWidth: "312px",
            maxHeight: "248px",
            overflow: "auto",
            children: /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                flexDirection: "column",
                position: "relative",
                children: [
                    t5,
                    t7
                ]
            })
        });
        $[18] = t5;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
};
export { useSymbols };
